import script from "./PaymentsPageCreatorBankAccountsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsPageCreatorBankAccountsTab.vue?vue&type=script&setup=true&lang=js"

import "./PaymentsPageCreatorBankAccountsTab.vue?vue&type=style&index=0&id=7a6badf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6badf2"]])

export default __exports__